import { AxisSwitcher, BorderGridContainer, GridBox, H2, SpacerWrapper } from '@ahmdigital/ui';
import React, { ReactNode } from 'react';

import styles from './styles.module.sass';

type TermsSectionProps = {
  heading?: string;
  id?: string;
  termsComponent: ReactNode;
};

const TermsSection = ({ heading = 'Things you should know', id = 'terms', termsComponent }: TermsSectionProps) => (
  <BorderGridContainer hideBorderTop>
    <GridBox padding="1rem">
      <div className={styles.wrapper}>
        <SpacerWrapper variant={['paddingTopSpacer2', 'paddingBottomSpacer2']}>
          <AxisSwitcher limit={2} threshold="44rem">
            <GridBox padding="1rem">
              <div data-testid="terms-heading-wrapper" id={id}>
                <H2 looksLike="h3" variant="marginBottomSpacer9">
                  {heading}
                </H2>
              </div>
            </GridBox>
            <GridBox minWidth="calc((100% / 10) * 6)" padding="1.5rem 1rem 1rem 1rem">
              {termsComponent}
            </GridBox>
          </AxisSwitcher>
        </SpacerWrapper>
      </div>
    </GridBox>
  </BorderGridContainer>
);

export default TermsSection;
